import React, { useState } from 'react';
import classNames from 'classnames';
import { HomepagePlatformSection, HomepagePlatformSectionButton } from '@/shared/types/homepage';
import Image from 'next/image';
import './index.less';
import VimeoLightbox from '../VimeoLightbox';
import Link from 'next/link';
import WithPietraComparator from '../WithPietraComparator';
import { map } from 'lodash-es';
import { Play } from '@/components/Common/Icons';

interface IProps {
  section: HomepagePlatformSection;
}
const TabSection = ({ section }: IProps) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState<boolean>(false);

  const { preTitle, title, buttons, description, vimeo } = section;

  return (
    <>
      <div className={classNames('platform-section', { reverse: !section.isTextLeft })}>
        <div className="content-max">
          <div className="text-section">
            <span className="pre-title" style={{ color: preTitle.color }}>
              {preTitle.text}
            </span>
            <h2 className="title" style={{ color: title.color }}>
              {title.text}
            </h2>
            <p className="description" style={{ color: description.color }}>
              {description.text}
            </p>
            <div className="btn-container">
              {map(buttons, (button: HomepagePlatformSectionButton) => {
                return (
                  <Link
                    key={button.text}
                    href={button.path}
                    className="action-btn"
                    style={{
                      backgroundColor: button.bgColor,
                      border: `1px solid ${button.borderColor}`,
                    }}
                    onClick={() => {}}
                  >
                    <span
                      style={{
                        color: button.color,
                      }}
                    >
                      {button.text}
                    </span>
                  </Link>
                );
              })}
            </div>

            <WithPietraComparator {...section.withPietraComparator} />
          </div>

          <div className="secondary-section image">
            <Image
              sizes="(min-width: 300px) calc(100vw-32px),(min-width: 607px) 575px, calc(100vw-32px)"
              alt={title.text}
              loading="lazy"
              width={575}
              height={475}
              onClick={() => setIsLightboxOpen(true)}
              src={section.image}
              className={vimeo && 'clickable'}
            />
            {section.playIcon && <Play className="play-icon" />}
          </div>
        </div>
      </div>
      {vimeo && <VimeoLightbox vimeo={vimeo} open={isLightboxOpen} onCancel={() => setIsLightboxOpen(false)} />}
    </>
  );
};

export default TabSection;
